"use strict";

var _regeneratorRuntime = require("D:\\new_kisan\\kisan_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _classCallCheck = require("D:\\new_kisan\\kisan_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("D:\\new_kisan\\kisan_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("D:\\new_kisan\\kisan_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("D:\\new_kisan\\kisan_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("D:\\new_kisan\\kisan_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var constants_1 = require("./constants");

var filter_1 = require("./filter");

var MetadataStatusFilter =
/*#__PURE__*/
function (_filter_1$BaseFilter) {
  _inherits(MetadataStatusFilter, _filter_1$BaseFilter);

  function MetadataStatusFilter() {
    _classCallCheck(this, MetadataStatusFilter);

    return _possibleConstructorReturn(this, _getPrototypeOf(MetadataStatusFilter).apply(this, arguments));
  }

  _createClass(MetadataStatusFilter, [{
    key: "receiveTrailers",
    value: function receiveTrailers(status) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _ref, code, details, metadata, metadataMap, receivedCode;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return status;

              case 2:
                _ref = _context.sent;
                code = _ref.code;
                details = _ref.details;
                metadata = _ref.metadata;

                if (!(code !== constants_1.Status.UNKNOWN)) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt("return", {
                  code: code,
                  details: details,
                  metadata: metadata
                });

              case 8:
                metadataMap = metadata.getMap();

                if (typeof metadataMap['grpc-status'] === 'string') {
                  receivedCode = Number(metadataMap['grpc-status']);

                  if (receivedCode in constants_1.Status) {
                    code = receivedCode;
                  }

                  metadata.remove('grpc-status');
                }

                if (typeof metadataMap['grpc-message'] === 'string') {
                  details = decodeURI(metadataMap['grpc-message']);
                  metadata.remove('grpc-message');
                }

                return _context.abrupt("return", {
                  code: code,
                  details: details,
                  metadata: metadata
                });

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }]);

  return MetadataStatusFilter;
}(filter_1.BaseFilter);

exports.MetadataStatusFilter = MetadataStatusFilter;

var MetadataStatusFilterFactory =
/*#__PURE__*/
function () {
  function MetadataStatusFilterFactory(channel) {
    _classCallCheck(this, MetadataStatusFilterFactory);

    this.channel = channel;
  }

  _createClass(MetadataStatusFilterFactory, [{
    key: "createFilter",
    value: function createFilter(callStream) {
      return new MetadataStatusFilter();
    }
  }]);

  return MetadataStatusFilterFactory;
}();

exports.MetadataStatusFilterFactory = MetadataStatusFilterFactory;